import PaymentUserInfo from './PaymentUserInfo';

export default PaymentUserInfo;
